import { css } from '@emotion/core'

export default () => {
  return css``
}
